<script lang="ts" setup>

//
// >>>>> TAG <<<<<
//

import { useI18n } from "vue-i18n";
import { buildMeta } from "~~/utils/meta-builder";

useHead(buildMeta({
	key: 'search', 
	follow: false
}))


const config = useRuntimeConfig()
const route = useRoute()
const i18n = useI18n()
const api = useStoryblokApi();
const localePath = useLocalePath();

const lang = i18n.locale.value
const language = lang === 'en' ? 'default' : lang 
const path = lang === 'en' ? '' : '/'+lang

const getSlug = (item: any): string=>{
	if(!item)return ''
	const slug= (item.full_slug as string).replace(`${item.lang}/`,'')
	return `/${slug}`
}

const categoriesResponse = await api.get("cdn/stories", {
	version: config.public.blog.mode,
	starts_with: "categories",
	language: language
}).catch((error) => {
	console.error('Could not load search categories from Storyblok', error)
	return null
})

const categories = (categoriesResponse?.data?.stories ?? []) as Array<any>
const stories = ref<Array<any>>([])

const loadStories = async (tag: string)=>{
	if (!tag) {
		stories.value = []
		return
	}

	try {
		const {data} = await api.get(`cdn/stories`, {
			version: config.public.blog.mode as 'draft' | 'published',
			resolve_relations: 'author,reviewer',
			language: language,
			starts_with: "posts",
			with_tag: tag
		})

		stories.value = data.stories as Array<any>

		for (const story of stories.value) {
			const resolvedCategories:any[] = []
			//console.log("story.content.category", story.content.category)
			if(story.content.category){
				for(const categoryId of story.content.category){
					const index = categories.findIndex(category=>category.uuid === categoryId)
				
					if(index !== -1){
					//	console.log('uuid', categoryId)
						resolvedCategories.push(categories[index])
					}

				}
				story.content['categories'] = resolvedCategories;
			}
			//console.log("resolvedCategories", resolvedCategories)
		}
	} catch (error) {
		console.error('Could not load tagged stories from Storyblok', error)
		stories.value = []
	}
}


//https://api.storyblok.com/v2/cdn/tags/?starts_with=posts&token=ZKVz5vYrHivRPiqP6HcOdwtt
await loadStories(route.query.tag as string)

watch(() => route.query.tag, (tag)=> {
	loadStories(tag as string)
})


const tagsResponse: any = await api.get(`cdn/tags`, {
	starts_with: "posts",
}).catch((error) => {
	console.error('Could not load search tags from Storyblok', error)
	return null
})

interface Tag {
	name: string
	taggings_count: number
}

const tags = (tagsResponse?.data?.tags ?? []) as Array<Tag>
tags.sort((a,b)=> {return a.taggings_count > b.taggings_count ? -1 : 1} )

</script>
<template>
	<div class="overflow-x-hidden bg-newdark-800">
		<Header theme="dark" />
		

		<div class="w-full max-w-screen-xl mx-auto px-10 text-white">

			<div class="flex flex-row ">
				<NuxtLink class="nav-link" :to="localePath('blog')">{{$t('nav.blog.title')}}</NuxtLink>
				<p class="px-2">/</p>
				<p>{{ route.query.tag }}</p>
			</div>

			<div class="gap-8 pt-16 masonry sm:masonry-sm md:masonry-md"> 
				<transition-group name="list">
					<PostItem v-for="item in stories" :key="item.id" :blok="item.content" :slug="getSlug(item)" />
				</transition-group>
			</div>

			<h3 class="text-xl font-bold pb-10 pt-2 text-white/50">Tags</h3>
				<div class="flex flex-wrap gap-4 pb-32">
					<NuxtLink 
						v-for="item in tags"
						:to="path+'/search?tag='+item.name"
						rel="nofollow"
						:class="{'bg-primary-500': route.query.tag === item.name}"
						class="tag"
						>{{ item.name }} <sm class="text-sm bg-white/30 rounded-full text-black px-2 ml-2"> {{ item.taggings_count }}</sm></NuxtLink>
				</div>

		</div>



		<Footer theme="dark" />
	</div>
</template>
